import Api from './Api';

const WALLETS_URL = `${process.env.REACT_APP_BASE_URL}/v2/wallets`;

export const getWallets = (portfolioId) =>
  Api.get(`${WALLETS_URL}/by-portfolio/${portfolioId}/balances`);

// Aggregates the latest snapshot of every wallet in the portfolio into one row
// per token ("how much USDC do I hold across all my wallets"). Rows come back
// already sorted by fiatValue descending, with no aggregate total.
export const getWalletBalancesByToken = (portfolioId) =>
  Api.get(`${WALLETS_URL}/by-portfolio/${portfolioId}/balances/by-token`);

export const getWalletsByPortfolio = (portfolioId) =>
  Api.get(`${WALLETS_URL}/by-portfolio/${portfolioId}`);

export const createWallet = (wallet) => Api.post(WALLETS_URL, wallet);

export const deleteWallet = (walletId) =>
  Api.delete(`${WALLETS_URL}/${walletId}`);

export const getWalletAddresses = (walletId) =>
  Api.get(`${WALLETS_URL}/${walletId}/addresses`);

export const addWalletAddress = (walletId, address) =>
  Api.post(`${WALLETS_URL}/${walletId}/addresses`, address);

export const deleteWalletAddress = (walletId, addressId) =>
  Api.delete(`${WALLETS_URL}/${walletId}/addresses/${addressId}`);
